<template>
  <v-menu>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on"  text>{{getName($store.state.current.role)}}<v-icon>mdi-chevron-down</v-icon></v-btn>
    </template>
    <v-list>
        <v-list-item @click="selectRole(per)" v-for="per in $store.getters['current/getRoles']" :key="per.id" link>{{getName(per)}}</v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import translateService from '../../helper/translateService.js'
export default {
  methods:{
    async selectRole(role){
      this.$store.commit('current/setRole', role);
      this.$emit('update', role);
      
      // Filtra o menu após mudar de role
      await this.$store.dispatch('current/filterMenuBySector');
      
      //Redireciona para página inicial
      if(this.$route.path !== '/app') {
        this.$router.push('/app');
      }
    },
    getName(item){
      return translateService.getName(item.names)
    }
  }
}
</script>

<style>

</style>